import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
/** 未匹配路由的明确降级页面，避免未知地址误进入编辑器。 */
export function NotFoundPage() {
    return (_jsxs("main", { className: "not-found-page", children: [_jsx("h1", { children: "\u9875\u9762\u4E0D\u5B58\u5728" }), _jsx("p", { children: "\u5F53\u524D\u5730\u5740\u6CA1\u6709\u5BF9\u5E94\u7684\u529F\u80FD\u9875\u9762\u3002" }), _jsx(Link, { to: "/", children: "\u8FD4\u56DE\u5DE5\u4F5C\u53F0" })] }));
}
